module.exports = __webpack_public_path__ + "img/4989676.png";